module.exports = __webpack_public_path__ + "img/secure.7e11c1d4.png";